import React from 'react';
import WhiteFilter from 'assets/images/white-filter.png';
import WhiteFilterWebp from 'assets/images/white-filter.png?as=webp';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';

const FadeIn = loadable(() => import('../common/FadeIn'));

const MediaContent = () => (
  <section className='media-content'>
    <div className='container'>
      <div className='media-content__grid'>
        <div className='media-content__content'>
          <h2 className='media-content__title'>Air 🍃 is everywhere and so are we.</h2>
          <div className='media-content__description'>
            <p>
              A
              {' '}
              <strong>100% remote</strong>
              {' '}
              and Slack-connected team, our squad sits in North America,
              South America, Europe, New Zealand, and Asia. Live outside one of those areas? Cool. We
              wouldn’t mind having a team member on every continent.
            </p>
          </div>
        </div>
        <figure className='media-content__image'>
          <LazyLoad>
            <FadeIn>
              <picture>
                <source srcSet={WhiteFilterWebp} type='image/webp' />
                <source srcSet={WhiteFilter} type='image/png' />
                <img src={WhiteFilter} alt='flowers' />
              </picture>
            </FadeIn>
          </LazyLoad>
        </figure>
      </div>
    </div>
  </section>

);

export default MediaContent;
